export const certificates = [
  {
    id: "INT-04250525-002",
    name: "Ram Manohar Gupta Palavrapu",
    college: "IIIT Hyderabad",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/rammnohar.png",
  },
  {
    id: "INT-04250525-001",
    name: "Jayaprakash Narayana Addala",
    college: "IIIT Hyderabad",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/jp.png",
  },
  {
    id: "INT-04250525-003",
    name: "Roshan Yacham",
    college: "IIIT Hyderabad",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/roshan.png",
  },
  // Example entries for different colleges (you can add actual certificate data here below)
  {
    id: "INT-06250725-070",
    name: "Gurram Varshini",
    college: "SRM AP",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/gurram_varshini.png",
  },
  {
    id: "INT-06250725-069",
    name: "Janllyn Avantikha",
    college: "Satyabhama Chennai",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/janllyn_avantikha.png",
  },
  {
    id: "INT-06250725-068",
    name: "Joshika Pachigulla",
    college: "SRM AP",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/joshika_pachigulla.png",
  },
  {
    id: "INT-06250725-067",
    name: "Kamatham Naga Sai Mokshitha",
    college: "SRM AP",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/kamatham_naga_sai_mokshitha.png",
  },
  {
    id: "INT-06250725-066",
    name: "Karra Nagar Harshitha",
    college: "SRM AP",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/karra_Naga_harshitha.png",
  },
  {
    id: "INT-06250725-065",
    name: "Sai Venkata Sandeep Garlapati",
    college: "SRM AP",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/sai_Venkata_Sandeep_garlapati.png",
  },
  {
    id: "INT-05251125-263",
    name: "Akula Pujitha",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Akula_Pujitha.png",
  },
  {
    id: "INT-05251125-264",
    name: "Murapaka Sai Sandeep Sharma",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Murapaka_Sai_Sandeep_Sharma.png",
  },
  {
    id: "INT-05251125-265",
    name: "Murumulla Kumaraswamy",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Murumulla_Kumaraswamy.png",
  },
  {
    id: "INT-05251125-266",
    name: "Saikumar Siddanathi",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Saikumar_Siddanathi.png",
  },
  {
    id: "INT-05251125-267",
    name: "Swetha Kurmadasu",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Swetha_Kurmadasu.png",
  },
  {
    id: "INT-05251125-268",
    name: "Tejaswi Nadiminti",
    college: "LENDI Institute of Engineering and Technology",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Tejaswi_Nadiminti.png",
  },
  {
    id: "INT-05251125-269",
    name: "Yepuganti Shanmuk Sriram Tej",
    college: "SASI Institute of Technology & Engineering",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Yepuganti_Shanmuk_Sriram_Tej.png",
  },
  {
    id: "INT-05251125-270",
    name: "Gayathri Korakanchu",
    college: "SASI Institute of Technology & Engineering",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Gayathri_Korakanchu.png",
  },
  {
    id: "INT-05251125-271",
    name: "Priyanka Vemparala",
    college: "SASI Institute of Technology & Engineering",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Priyanka_Vemparala.png",
  },
  {
    id: "INT-05251125-272",
    name: "Boddupalli Rukmini Devi",
    college: "SASI Institute of Technology & Engineering",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Boddupalli_Rukmini_Devi.png",
  },
  {
    id: "INT-05251125-273",
    name: "Yamini Lakshmi Prasanna Tirugu",
    college: "SASI Institute of Technology & Engineering",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Yamini_Lakshmi_Prasanna_Tirugu.png",
  },
  {
    id: "INT-06251125-274",
    name: "Goswami Nagesh",
    college: "Avinash College of Commerce",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Goswami_Nagesh.png",
  },
  {
    id: "INT-06251125-275",
    name: "Sridhar Maturi",
    college: "Avinash College of Commerce",
    certificateUrl: "https://ccc-media-assets.s3.ap-south-1.amazonaws.com/cccsnv/certificates/Sridhar_Maturi.png",
  },
];

// Helper function to find certificate by ID
export const getCertificateById = (id) => {
  return certificates.find(cert => cert.id === id);
};

// Helper function to get certificates by college
export const getCertificatesByCollege = (college) => {
  return certificates.filter(cert => cert.college === college);
};

// Helper function to get all colleges
export const getAllColleges = () => {
  return [...new Set(certificates.map(cert => cert.college))];
}; 